import React from "react";
import { getRegionKey } from "@certn/utils";
import { SelectItem } from "@certn/cascadia-react";

/**
 * Maps region key to default datacenter
 * @param region - Region key ("ca", "uk", "au")
 * @returns Datacenter ID ("dc2", "dc3", "dc4", "dc5")
 */
export function getDatacenterFromRegion(
  region: string
): "dc2" | "dc3" | "dc4" | "dc5" {
  switch (region) {
    case "au":
      return "dc2"; // AUS
    case "uk":
      return "dc3"; // UK/EMEA
    case "ca":
      return "dc4"; // US
    default:
      return "dc2";
  }
}

/**
 * Gets the default datacenter based on the current region
 * @returns Datacenter ID ("dc2", "dc3", "dc4", "dc5")
 */
export function getDefaultDatacenter(): "dc2" | "dc3" | "dc4" | "dc5" {
  const region = getRegionKey();
  return getDatacenterFromRegion(region);
}

/**
 * Renders datacenter SelectItem components
 * @returns Array of SelectItem components for datacenter options
 */
export function renderDatacenterOptions(): React.ReactElement[] {
  return [
    React.createElement(SelectItem, { key: "dc2", id: "dc2" }, "DC2 (AUS)"),
    React.createElement(SelectItem, { key: "dc3", id: "dc3" }, "DC3 (UK/EMEA)"),
    React.createElement(SelectItem, { key: "dc4", id: "dc4" }, "DC4 (US)"),
    React.createElement(SelectItem, { key: "dc5", id: "dc5" }, "DC5 (SEA)"),
  ];
}
